import React from 'react';

interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'style'> {
  children?: React.ReactNode;
  width?: string | number;
  height?: string | number;
  maxWidth?: string | number;
  padding?: string;
  flexDirection?: 'row' | 'column';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around';
  gap?: string | number;
  borderRadius?: string | number;
  borderTopLeftRadius?: string | number;
  borderTopRightRadius?: string | number;
  borderBottomLeftRadius?: string | number;
  borderBottomRightRadius?: string | number;
  background?: string;
  boxShadow?: string;
  borderTop?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const Card: React.FC<CardProps> = ({
  children,
  width = 'auto',
  height = 'auto',
  maxWidth,
  padding = '16px 20px',
  flexDirection = 'column',
  alignItems = 'flex-start',
  justifyContent = 'flex-start',
  gap = '10px',
  borderRadius = '16px',
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTop,
  background = 'var(--Color-background-normal, #FFF)',
  boxShadow = '0 1px 2px 0 var(--color-alpha-shadow1, rgba(0, 0, 0, 0.05)), 0 0 5px 0 var(--color-alpha-shadow1, rgba(0, 0, 0, 0.05))',
  style = {},
  className = '',
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...rest
}) => {
  // 개별 모서리 radius 계산
  const computedBorderRadius = {
    borderTopLeftRadius: borderTopLeftRadius ?? borderRadius,
    borderTopRightRadius: borderTopRightRadius ?? borderRadius,
    borderBottomLeftRadius: borderBottomLeftRadius ?? borderRadius,
    borderBottomRightRadius: borderBottomRightRadius ?? borderRadius,
  };

  return (
    <div
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rest}
      style={{
        display: 'flex',
        width,
        height,
        maxWidth,
        padding,
        flexDirection,
        alignItems,
        justifyContent,
        gap,
        background,
        boxShadow,
        borderTop,
        borderRadius: borderRadius, // 명시적으로 설정
        ...computedBorderRadius,
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default Card;
